import { QueryHookOptions, useQuery } from "@apollo/react-hooks";

import instructorDetails from "../graph-ql/instructorDetails.graphql";

const useQueryInstructorDetails = (opts?: QueryHookOptions) =>
  useQuery(instructorDetails, opts);

export default useQueryInstructorDetails;
